class TrustedShops {

    private trustedShopsContainer: HTMLElement;

    constructor(container: HTMLElement) {
        this.trustedShopsContainer = container;
        this.initTrustedShopsBadge();
    }

    private initTrustedShopsBadge = (): void => {
        const trustedShopsId: string = this.trustedShopsContainer.dataset.tsid;

        if (!trustedShopsId) {
            return;
        }

        /* eslint-disable-next-line */
        window['_tsConfig'] = {
            yOffset: '',
            variant: 'floating',
            customElementId: 'trusted-shops-container',
            trustcardDirection: '',
            customBadgeWidth: '',
            customBadgeHeight: '',
            disableResponsive: 'false',
            disableTrustbadge: 'false',
            responsive: {
                variant: 'custom_reviews',
                customElementId: 'trusted-shops-container',
            },
        };
        const scriptElem: HTMLScriptElement = document.createElement('script');
        scriptElem.src = `//widgets.trustedshops.com/js/${trustedShopsId}.js`;
        scriptElem.type = 'text/javascript';
        scriptElem.async = true;
        document.head.appendChild(scriptElem);
    }
}

export default class TrustedShopsHandler {

    public static init = (): void => {
        const trustedShopsContainer: HTMLElement = document.querySelector('#trusted-shops-container');

        if (trustedShopsContainer) {
            new TrustedShops(trustedShopsContainer);
        }
    }
}
